import React from 'react'
import FormElement from './FormElement'

const Checkbox = ({ form, field, meta, label, ...props }) => {
    const { required } = props
    const { name } = field
    const { touched, errors } = form
    const error = touched[name] && errors[name]

    return (
        <FormElement
            elementClass="form-element--checkbox"
            name={field.name}
            value={field.value}
            error={error}
            {...props}
        >
            {() => (
                <div className="option">
                    <input
                        id={field.name}
                        type="checkbox"
                        checked={field.value}
                        {...field}
                        {...props}
                    />
                    {label && <label htmlFor={field.name}>{label}{required && <sup>*</sup>}</label>}
                </div>
            )}
        </FormElement>
    )
}

export default Checkbox
